// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NsHomeMarketPurchasingOnlyBanner__container{width:100%;background-color:#fde7e7;border:1px solid #fde7e7;border-radius:4px;margin:0;padding:0}.NsHomeMarketPurchasingOnlyBanner__content{display:flex;justify-content:center;padding:12px 16px;gap:12px}.NsHomeMarketPurchasingOnlyBanner__icon{display:flex;align-items:center;color:#856404;flex-shrink:0}.NsHomeMarketPurchasingOnlyBanner__message{font-size:14px;line-height:1.4}@media(max-width: 768px){.NsHomeMarketPurchasingOnlyBanner__content{padding:10px 12px;gap:8px}.NsHomeMarketPurchasingOnlyBanner__message{font-size:13px}}", ""]);
// Exports
exports.locals = {
	"container": "NsHomeMarketPurchasingOnlyBanner__container",
	"content": "NsHomeMarketPurchasingOnlyBanner__content",
	"icon": "NsHomeMarketPurchasingOnlyBanner__icon",
	"message": "NsHomeMarketPurchasingOnlyBanner__message"
};
module.exports = exports;
